export default "#1C1C1C";
const coal = `#1C1C1C`;

export { coal };
